import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagsEnum } from '../../enums';
import { VisitorIntelApiService } from '../../services/api';
import { UserService } from 'src/app/core/services/user.service';
import { User } from 'src/app/core/models/user.model';
import { filter, map, switchMap } from 'rxjs/operators';
import { LoadingService } from '../../services';

const LOADING_TAG: string = 'visitor-intel-loading-tag';

@Component({
    selector: 'app-visitor-intel-script',
    templateUrl: './visitor-intel-script.component.html',
    styles: [`
    :host {
      --mat-form-field-filled-input-text-color: currentcolor;
      --mat-form-field-filled-caret-color: currentcolor;
    }
    .no-underline + * .mat-form-field::after {
      position: absolute;
      content: "";
      bottom: 18px;
      border-bottom: 4px solid #f7f7f7;
      z-index: 1;
      width: 100%;
    }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VisitorIntelScriptComponent implements OnInit {
    @Input() textareaRows: number = 14;
    @Input() titleClasses: string;

    isCopiedTag: boolean;
    uuid$: Observable<string>;
    siScript$: Observable<string>;

    readonly isLoading$: Observable<boolean>;
    readonly featureFlagsEnum: typeof FeatureFlagsEnum = FeatureFlagsEnum;

    constructor(
        private readonly visitorIntelApiService: VisitorIntelApiService,
        private readonly userService: UserService,
        private readonly loadingService: LoadingService
    ) {
        this.isLoading$ = this.loadingService.getIsLoading(LOADING_TAG);
    }

    ngOnInit() {
        this.setObservables();
    }

    private setObservables(): void {
        const user$: Observable<User> = this.userService.getUserData().pipe(filter((user: User) => Boolean(user)));

        this.uuid$ = user$.pipe(map(({ uuid }: User) => uuid));
        this.siScript$ = user$.pipe(
            map(({ account_id }: User) => account_id),
            switchMap((account_id: number) => this.getScript(account_id)),
        )
    }

    private getScript(accountId: number): Observable<string> {
        return this.loadingService.loadingWrapper(this.visitorIntelApiService.getScript(accountId).pipe(map((item: { script: string }) => item?.script)), LOADING_TAG);
    }
}
